// components/AddFacture.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaTrash, FaSave } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addFacture } from "../services/FactureService";
import { useSelector } from "react-redux";
import { getClient } from "../services/ClientService";
import { getAutres, getBatiment } from "../services/SecteurServices";
import { tvainfo } from "../services/LoginService"; // import de ta fonction Me()
import * as LoadingIcons from "react-loading-icons";

const AddFacture = () => {
    const token = useSelector((state) => state.auth.token);
    const [loading, setLoading] = useState(true);

    const [tva_inclus, setTvaInclus] = useState(false);
    const [activeRates, setActiveRates] = useState([]); // tableau des taux actifs
    const navigate = useNavigate();


    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [secteursBatiment, setSecteursBatiment] = useState([]);
    const [secteursAutres, setSecteursAutres] = useState([]);
    const [selectedBatiment, setSelectedBatiment] = useState([]); // tableau d'id
    const [selectedAutres, setSelectedAutres] = useState([]);     // tableau d'id
    useEffect(() => {
        if (!token) {
            navigate("/login", { state: { message: "Session expirée" } });
            return;
        }

        const fetchData = async () => {
            try {
                // 1. Récupération TVA
                const resTVA = await tvainfo(token);
                let inclus = false;
                let active = [];
                if (resTVA.success) {
                    inclus = resTVA.tva_inclus ?? false;
                    const rates = resTVA.tva_rates || {};
                    active = Object.keys(rates)
                        .filter((k) => rates[k])
                        .sort((a, b) => parseFloat(a) - parseFloat(b));
                }
                setTvaInclus(inclus);
                setActiveRates(active);
                // 4. Fin du chargement
                setLoading(false);
                // 2. Clients
                const clientsRes = await getClient(token);
                setClients(clientsRes);

                // 3. Secteurs
                const batimentRes = await getBatiment(token);
                const autresRes = await getAutres(token);
                setSecteursBatiment(batimentRes);
                setSecteursAutres(autresRes);

            } catch (err) {
                console.error(err);
                toast.error("Erreur lors du chargement des données.");
            }

        };

        fetchData();
    }, [token, navigate]);
    useEffect(() => {
        if (activeRates.length > 0) {
            setFacture(f => {
                const newLignes = [...f.lignes];
                newLignes[0].taux_tva = newLignes[0].taux_tva || parseFloat(activeRates[0]);
                return { ...f, lignes: newLignes };
            });
        }
    }, [activeRates]);

    // Récupérer secteurs depuis backend
    useEffect(() => {
        if (token) {
            getBatiment(token).then(setSecteursBatiment);
            getAutres(token).then(setSecteursAutres);
        }
    }, [token]);
    const [facture, setFacture] = useState({
        numero: "",
        date_emission: new Date().toISOString().slice(0, 10),
        date_echeance: "",
        statut: "brouillon",
        type_paiement: "",
        acompte_centimes: 0,
        lignes: [
            {
                designation: "",
                quantite: 1,
                unite: "",
                prix_unitaire_centimes: 0,
                taux_tva: activeRates[0] ? parseFloat(activeRates[0]) : 0, // ⬅️ taux par défaut
                taux_remise: 0,
                total_ligne_centimes: 0,
            },
        ],
    });

    const statuts = [
        { label: "Brouillon", value: "brouillon" },
        { label: "Envoyée", value: "envoye" },
        { label: "Partiellement payée", value: "partiel" },
        { label: "Payée", value: "paye" },
        { label: "En retard", value: "retard" },
        { label: "Annulée", value: "annule" },
    ];

    const typesPaiement = [
        { label: "Virement", value: "virement" },
        { label: "Chèque", value: "cheque" },
        { label: "Espèces", value: "espece" },
    ];
    // Calcul des TVA par taux
    const tvaParTaux = React.useMemo(() => {
        const result = {};
        activeRates.forEach(rate => {
            result[rate] = 0;
        });

        facture.lignes.forEach((ligne) => {
            const totalHT = parseFloat(ligne.total_ligne_centimes) || 0;
            const tauxTVA = (parseFloat(ligne.taux_tva) || 0).toFixed(2); // clé string

            if (result.hasOwnProperty(tauxTVA)) {
                result[tauxTVA] += (totalHT * parseFloat(tauxTVA)) / 100;
            } else {
                result[tauxTVA] = (totalHT * parseFloat(tauxTVA)) / 100;
            }
        });

        return result;
    }, [facture.lignes, activeRates]);



    const [totaux, setTotaux] = useState({
        sous_total_centimes: 0,
        remise_centimes: 0,
        tva_centimes: 0,
        total_centimes: 0,
    });

    useEffect(() => {
        if (token) {
            getClient(token).then((res) => setClients(res));
        }
    }, [token]);


    const addLigne = () => {
        setFacture({
            ...facture,
            lignes: [
                ...facture.lignes,
                {
                    designation: "",
                    quantite: 1,
                    unite: "",
                    prix_unitaire_centimes: 0,
                    taux_tva: activeRates[0] ? parseFloat(activeRates[0]) : 0, // <-- taux TVA par défaut
                    taux_remise: 0,
                    total_ligne_centimes: 0,
                },
            ],
        });
    };
    const removeLigne = (index) => { const newLignes = [...facture.lignes]; newLignes.splice(index, 1); setFacture({ ...facture, lignes: newLignes }); };
    useEffect(() => {
        let sousTotal = 0, remise = 0, tva = 0;

        facture.lignes.forEach((ligne) => {
            const prix = parseFloat(ligne.prix_unitaire_centimes) || 0;
            const quantite = parseFloat(ligne.quantite) || 0;
            const remiseLigne = parseFloat(ligne.taux_remise) || 0;
            const tauxTVA = parseFloat(ligne.taux_tva) || 0;

            const ligneTotal = prix * quantite;
            const ligneRemise = (ligneTotal * remiseLigne) / 100;
            const ligneHT = ligneTotal - ligneRemise;

            const ligneTVA = (ligneHT * tauxTVA) / 100;

            sousTotal += ligneHT;
            remise += ligneRemise;
            tva += ligneTVA;

            // Mettre à jour le total de la ligne (HT)
            ligne.total_ligne_centimes = ligneHT;
        });

        setFacture(f => ({ ...f })); // force re-render pour que total_ligne_centimes soit pris en compte
        setTotaux({
            sous_total_centimes: sousTotal,
            remise_centimes: remise,
            tva_centimes: tva,
            total_centimes: sousTotal + tva,
        });
    }, [facture?.lignes]);

    const updateLigne = (index, field, value) => {
        const newLignes = [...facture.lignes];
        newLignes[index][field] = value;

        const prix = parseFloat(newLignes[index].prix_unitaire_centimes) || 0;
        const quantite = parseFloat(newLignes[index].quantite) || 0;
        const remise = parseFloat(newLignes[index].taux_remise) || 0;

        // Total HT (avant TVA)
        const ligneTotal = prix * quantite;
        const ligneRemise = (ligneTotal * remise) / 100;
        newLignes[index].total_ligne_centimes = ligneTotal - ligneRemise;


        setFacture({ ...facture, lignes: newLignes });
    };




    const handleSave = async () => {
        if (!selectedClient) { toast.error("Veuillez sélectionner un client."); return; }
        // Vérifie que chaque ligne est valide
        const lignesValides = facture.lignes.filter(ligne =>
            ligne.designation?.trim() &&
            parseFloat(ligne.quantite) > 0 &&
            parseFloat(ligne.prix_unitaire_centimes) > 0
        );

        if (lignesValides.length !== facture.lignes.length) {
            toast.error("Toutes les lignes doivent avoir une désignation, une quantité >= 1 et un prix unitaire > 0.");
            return;
        }
        try {
            setLoading(true);
            await addFacture({
                ...facture, client_id: selectedClient.id, sous_total_centimes: totaux.sous_total_centimes, remise_centimes: totaux.remise_centimes, tva_centimes: totaux.tva_centimes, total_centimes: totaux.total_centimes, lignes: lignesValides, type_paiement: facture.type_paiement || null, acompte_centimes: Math.min(facture.acompte_centimes, totaux.total_centimes), secteurs_batiment: selectedBatiment,
                secteurs_autres: selectedAutres,
            });
            setLoading(false);
            navigate("/EspaceClient/factures", { state: { message: "Facture ajoutée avec succès !" } });
        } catch (err) {
            toast.error(err.message || "Erreur lors de l'ajout de la facture.");
            setLoading(false);
        }
    };
    if (loading)
        return (
            <div className="flex flex-col justify-center min-h-screen items-center ">
                <LoadingIcons.SpinningCircles
                    stroke="#2218eeff"
                    fill="#2218eeff"
                    strokeWidth={3}
                    height={40}
                    width={40}
                />
                <span className="ml-3 text-gray-600 font-medium">
                    Chargement
                </span>
            </div>
        );
    return (
        <div className="min-h-screen p-6 flex flex-col gap-2">
            <div  >
                <ToastContainer position="top-right" autoClose={3000} />
                <div className="flex justify-between items-center mb-2">
                    <h1 className="font-bold text-2xl">Ajouter une Facture</h1>
                    <button onClick={handleSave} className="bg-color3 hover:bg-color3/80 text-white px-4 py-2 rounded-lg flex items-center gap-2"><FaSave /> Enregistrer</button>
                </div>

                <div className="flex flex-col gap-5">
                    <div className="bg-white shadow-md rounded-lg p-4">
                        <h2 className="font-semibold mb-4">Informations de la facture</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Client</label>
                                <select className="border rounded-md px-2 py-1" value={selectedClient?.id || ""} onChange={(e) => setSelectedClient(clients.find(c => c.id === Number(e.target.value)))}>
                                    <option value="">-- Sélectionner --</option>
                                    {clients.map(c => <option key={c.id} value={c.id}>{c.nom_affichage} ({c.email || "-"})</option>)}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Statut</label>
                                <select className="border rounded-md px-2 py-1" value={facture.statut} onChange={(e) => setFacture({ ...facture, statut: e.target.value })}>
                                    {statuts.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Type de paiement</label>
                                <select className="border rounded-md px-2 py-1" value={facture.type_paiement || ""} onChange={(e) => setFacture({ ...facture, type_paiement: e.target.value })}>
                                    <option value="">-- Sélectionner --</option>
                                    {typesPaiement.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Acompte</label>
                                <input type="number" min={0} max={totaux.total_centimes} value={facture.acompte_centimes} onChange={(e) => setFacture({ ...facture, acompte_centimes: Math.min(parseFloat(e.target.value) || 0, totaux.total_centimes) })} className="border rounded-md px-2 py-1" />
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Date d'émission</label>
                                <input type="date" className="border rounded-md px-2 py-1" value={facture.date_emission} onChange={(e) => { const newDate = e.target.value; setFacture({ ...facture, date_emission: newDate, date_echeance: facture.date_echeance < newDate ? newDate : facture.date_echeance }); }} />
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Date d'échéance</label>
                                <input type="date" className="border rounded-md px-2 py-1" value={facture.date_echeance} min={facture.date_emission} onChange={(e) => setFacture({ ...facture, date_echeance: e.target.value })} />
                            </div>
                        </div>
                        <div className="bg-white shadow-md rounded-xl p-6 mb-6">
                            <h2 className="text-lg font-semibold mb-4">Secteurs</h2>

                            {/* Bâtiment */}
                            <h3 className="text-sm font-medium text-gray-600 mb-2">Bâtiment</h3>
                            <div className="flex flex-wrap gap-3 mb-4">
                                {secteursBatiment.map((s) => {
                                    const isSelected = selectedBatiment.includes(s.id);
                                    return (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onClick={() =>
                                                setSelectedBatiment((prev) =>
                                                    prev.includes(s.id)
                                                        ? prev.filter((id) => id !== s.id)
                                                        : [...prev, s.id]
                                                )
                                            }
                                            className={`px-3 py-1 rounded-full text-sm font-medium border transition ${isSelected
                                                ? "bg-green-600 text-white border-green-600 shadow"
                                                : "bg-green-50 text-green-700 border-green-300 hover:bg-green-100"
                                                }`}
                                        >
                                            {s.nom}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Autres */}
                            <h3 className="text-sm font-medium text-gray-600 mb-2">Autres</h3>
                            <div className="flex flex-wrap gap-3">
                                {secteursAutres.map((s) => {
                                    const isSelected = selectedAutres.includes(s.id);
                                    return (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onClick={() =>
                                                setSelectedAutres((prev) =>
                                                    prev.includes(s.id)
                                                        ? prev.filter((id) => id !== s.id)
                                                        : [...prev, s.id]
                                                )
                                            }
                                            className={`px-3 py-1 rounded-full text-sm font-medium border transition ${isSelected
                                                ? "bg-gray-700 text-white border-gray-700 shadow"
                                                : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                                                }`}
                                        >
                                            {s.nom}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                    </div>

                    {/* Lignes facture */}
                    {/* Lignes facture */}
                    {/* Lignes facture */}
                    <div className="bg-white shadow-md rounded-lg p-4 w-full">
                        <h2 className="font-semibold mb-2">Lignes de facture</h2>

                        <table className="w-full text-sm text-left border-collapse mb-4">
                            <thead className="bg-color1 text-color2 uppercase text-xs font-semibold">
                                <tr>
                                    <th className="px-3 py-2 text-left">Désignation</th>
                                    <th className="px-3 py-2 w-24 text-center">Qté</th>
                                    <th className="px-3 py-2 w-24 text-center">Unité</th>
                                    <th className="px-3 py-2 w-32 text-center">Prix Unitaire</th>
                                    <th className="px-3 py-2 w-24 text-center">TVA (%)</th>
                                    <th className="px-3 py-2 w-24 text-center">Remise (%)</th>
                                    <th className="px-3 py-2 w-32 text-center">Total HT</th>
                                    {facture.lignes.length > 1 && <th className="px-3 py-2 w-16">Action</th>}
                                </tr>
                            </thead>

                            <tbody>
                                {facture.lignes.map((ligne, index) => (
                                    <tr key={index} className="border-b hover:bg-gray-50">
                                        <td className="px-2 py-1">
                                            <textarea
                                                value={ligne.designation}
                                                onChange={(e) => updateLigne(index, "designation", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1 resize-none"
                                                rows={4}
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={1}
                                                value={ligne.quantite}
                                                onChange={(e) => updateLigne(index, "quantite", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="text"
                                                value={ligne.unite}
                                                onChange={(e) => updateLigne(index, "unite", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={0}
                                                value={ligne.prix_unitaire_centimes}
                                                onChange={(e) => updateLigne(index, "prix_unitaire_centimes", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>
                                        <td className="px-2 py-1">
                                            {tva_inclus && activeRates.length > 0 ? (
                                                <select
                                                    value={ligne.taux_tva ?? activeRates[0]}   // ⬅️ si pas défini → prend le 1er taux
                                                    onChange={(e) =>
                                                        updateLigne(index, "taux_tva", parseFloat(e.target.value))
                                                    }
                                                    className="w-full border border-gray-300 rounded-md px-1 py-1"
                                                >
                                                    {activeRates.map((taux) => (
                                                        <option key={taux} value={parseFloat(taux)}>
                                                            {taux}
                                                        </option>
                                                    ))}
                                                </select>


                                            ) : (
                                                <p className="text-center">-</p>
                                            )}
                                        </td>


                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={0}
                                                max={100}
                                                value={ligne.taux_remise}
                                                onChange={(e) => {
                                                    let value = parseFloat(e.target.value) || 0;
                                                    if (value > 100) value = 100;
                                                    if (value < 0) value = 0;
                                                    updateLigne(index, "taux_remise", value);
                                                }}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1 font-bold text-center">
                                            {ligne.total_ligne_centimes.toFixed(2)} €
                                        </td>

                                        {facture.lignes.length > 1 && (
                                            <td className="px-2 py-1 text-center">
                                                <button
                                                    onClick={() => removeLigne(index)}
                                                    className="text-red-600 hover:text-red-800"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="flex justify-end mb-4">
                            <button
                                onClick={addLigne}
                                className="bg-color3 hover:bg-color3/80 text-white px-3 py-1 rounded-lg flex items-center gap-1"
                            >
                                <FaPlus /> Ajouter une ligne
                            </button>
                        </div>

                        {/* Totaux */}
                        <div className="grid grid-cols-[140px_120px] gap-y-1 justify-end items-end">
                            {/* Total HT */}
                            {totaux.sous_total_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left">Total HT :</span>
                                    <span className="text-right">{totaux.sous_total_centimes.toFixed(2)} €</span>
                                </>
                            )}

                            {/* Remise */}
                            {totaux.remise_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left">Remise :</span>
                                    <span className="text-right">{totaux.remise_centimes.toFixed(2)} €</span>
                                </>
                            )}

                            {/* TVA par taux */}
                            {tva_inclus &&
                                Object.keys(tvaParTaux).length > 0 &&
                                activeRates
                                    .filter((rate) => (tvaParTaux[parseFloat(rate).toFixed(2)] || 0) > 0)
                                    .map((rate) => {
                                        const key = parseFloat(rate).toFixed(2);
                                        return (
                                            <React.Fragment key={key}>
                                                <span className="font-bold text-left">TVA ({rate}) :</span>
                                                <span className="text-right">{tvaParTaux[key].toFixed(2)} €</span>
                                            </React.Fragment>
                                        );
                                    })}

                            {/* Total TVA */}
                            {totaux.tva_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left">Total TVA :</span>
                                    <span className="text-right">{totaux.tva_centimes.toFixed(2)} €</span>

                                    {/* Total TTC */}
                                    <span className="font-bold text-left">Total TTC :</span>
                                    <span className="text-right">{totaux.total_centimes.toFixed(2)} €</span>
                                </>
                            )}

                            {/* Acompte */}
                            {facture.acompte_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left text-green-600">Acompte :</span>
                                    <span className="text-right text-green-600 font-semibold">{facture.acompte_centimes.toFixed(2)} €</span>

                                    {/* Net à payer */}
                                    {tva_inclus && totaux.total_centimes > 0 && (
                                        <>
                                            <span className="font-bold text-left">Reste à payer :</span>
                                            <span className="text-right">{(totaux.total_centimes - facture.acompte_centimes).toFixed(2)} €</span>
                                        </>
                                    )}
                                </>
                            )}
                        </div>


                    </div>



                </div>
            </div>

        </div>
    );
};

export default AddFacture;
